import { createContext } from 'react';

/** True inside a modal that, on a phone, fills the screen with its close button in the top-right corner */
export const ModalCloseButtonContext = createContext(false);
